// calendar.js
var min = +1;
var currentTime = new Date();

//Replace 15 to whatever time you want the cut off, for weekdays.
if (currentTime.getHours() >= 15) {
    min = +2;
}
//Replace 12 to whatever time you want the cut off, for weekends.
if (currentTime.getHours() >= 13 && (currentTime.getDay() == 0 || currentTime.getDay() == 6)) {
    min = +2;
}

//List of dates to block out
var dates = ['29/03/2024','31/03/2024','01/04/2024','06/05/2024','27/05/2024','26/08/2024','25/12/2024','26/12/2024','23/06/2024'];

function DisableDates(date) {
    var string = jQuery.datepicker.formatDate('dd/mm/yy', date);
    return [dates.indexOf(string) == -1];
}

var previousValue = null;

$(function() {
    $("#datepicker").datepicker({
        showButtonPanel: true,
        closeText: 'Clear',
        constrainInput: true,
        minDate: min,
        maxDate: '+6M',
        dateFormat: "dd/mm/yy",
        onSelect: function(date) {
            if (previousValue == date) {
                unselectedDate();
                $(this).datepicker('setDate', null);
                $('#selectedDate').val('').hide();
                $('#dateLabel').hide();
                previousValue = null;
            } else {
                $('#selectedDate').val(date).show();
                $('#dateLabel').show();
                previousValue = date;
            }
        },
        beforeShowDay: DisableDates,
        defaultDate: null // Add this line
    });
});

function unselectedDate() {
    document.getElementById("unselDate").style.display = "block";
    document.getElementById("unselDate").innerHTML = "Date has been unselected! Pick a date again if needed.";
    setTimeout(function() {
        document.getElementById("unselDate").style.display = "none";
    }, 2500);
}
